import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { imageConfigDefault } from './helpers';
const SolitoImageContext = createContext(imageConfigDefault);
export const SolitoImageProvider = ({ children, ...rest }) => {
    const parent = useContext(SolitoImageContext);
    const [context] = useState(() => ({
        ...parent,
        ...rest,
    }));
    return (_jsx(SolitoImageContext.Provider, { value: context, children: children }));
};
export const useSolitoImageContext = () => useContext(SolitoImageContext);
//# sourceMappingURL=context.js.map